export const animationsParams = {
	duration: '800ms'
};